import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
interface TimerSkeletonProps {
  withoutMd?: boolean;
}
const TimerDigitSkeleton: FC<{
  withoutMd?: boolean;
}> = t0 => {
  const $ = _c(7);
  const {
    withoutMd: t1
  } = t0;
  const withoutMd = t1 === undefined ? false : t1;
  const t2 = `rounded-[3px] bg-white/20 ${!withoutMd ? "h-8 w-6 md:h-12 md:w-8" : "h-12 w-8"}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <div className={t2} aria-hidden="true" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `rounded-[3px] bg-white/20 ${!withoutMd ? "h-8 w-6 md:h-12 md:w-8" : "h-12 w-8"}`;
  let t5;
  if ($[2] !== t4) {
    t5 = <div className={t4} aria-hidden="true" />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t3 || $[5] !== t5) {
    t6 = <div className="flex gap-0.5">{t3}{t5}</div>;
    $[4] = t3;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
const TimerSeparatorSkeleton: FC<{
  withoutMd?: boolean;
}> = t0 => {
  const $ = _c(5);
  const {
    withoutMd: t1
  } = t0;
  const withoutMd = t1 === undefined ? false : t1;
  const t2 = `flex w-full items-center justify-center ${!withoutMd ? "h-8 md:h-12" : "h-12"}`;
  const t3 = `font-medium text-white/30 ${!withoutMd ? "text-[16px] md:text-[24px]" : "text-[24px]"}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <span className={t3}>:</span>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t4) {
    t5 = <div className="flex w-[7px] flex-col items-center justify-center pb-[5px] pt-0"><div className={t2}>{t4}</div></div>;
    $[2] = t2;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
};
export const TimerSkeleton: FC<TimerSkeletonProps> = t0 => {
  const $ = _c(2);
  const {
    withoutMd: t1
  } = t0;
  const withoutMd = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== withoutMd) {
    t2 = <div className="flex animate-pulse items-center gap-0.5"><TimerDigitSkeleton withoutMd={withoutMd} /><TimerSeparatorSkeleton withoutMd={withoutMd} /><TimerDigitSkeleton withoutMd={withoutMd} /><TimerSeparatorSkeleton withoutMd={withoutMd} /><TimerDigitSkeleton withoutMd={withoutMd} /></div>;
    $[0] = withoutMd;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};